<template>
  <div class="v2-date-picker-wrapper">
    <label
      v-if="label"
      class="v2-date-picker__label"
    >{{ label }}</label>
    <div class="v2-date-picker__input-group">
      <flat-pickr
        ref="datePicker"
        class="v2-date-picker"
        :value="value"
        :config="mergedConfig"
        :disabled="disabled"
        v-on="$listeners"
        @input="val => $emit('input', val)"
      />
      <button
        type="button"
        class="v2-date-picker__toggle"
        :disabled="disabled"
        @click="toggle"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <rect
            x="3"
            y="4"
            width="18"
            height="18"
            rx="2"
            ry="2"
          />
          <line
            x1="16"
            y1="2"
            x2="16"
            y2="6"
          />
          <line
            x1="8"
            y1="2"
            x2="8"
            y2="6"
          />
          <line
            x1="3"
            y1="10"
            x2="21"
            y2="10"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'

const { KP_DATE_FORMAT } = c

export default {
  name: 'V2DatePicker',
  components: { flatPickr },
  props: {
    value: { type: [String, Date], default: '' },
    config: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
    placeholder: { type: String, default: 'Select date...' },
  },
  computed: {
    mergedConfig() {
      return {
        dateFormat: KP_DATE_FORMAT.CONFIG,
        ...this.config,
      }
    },
  },
  methods: {
    toggle() {
      if (this.$refs.datePicker?.$el?._flatpickr) {
        this.$refs.datePicker.$el._flatpickr.toggle()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-date-picker-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--v2-space-1);
}

.v2-date-picker__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v2-foreground);
}

.v2-date-picker__input-group {
  display: flex;
  position: relative;
}

.v2-date-picker__toggle {
  position: absolute;
  right: var(--v2-space-2);
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: var(--v2-space-1);
  cursor: pointer;
  color: var(--v2-muted-foreground);
  display: flex;
  align-items: center;

  &:hover {
    color: var(--v2-primary);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>

<style lang="scss">
/* Glass input — surface-2 + blur-sm. Matches V2Input recipe. */
.v2-date-picker.flatpickr-input {
  width: 100%;
  min-height: 38px;
  padding: var(--v2-space-2) var(--v2-space-3);
  padding-right: 2.5rem;
  font-family: var(--v2-font-sans);
  font-size: 0.875rem;
  color: var(--v2-foreground);
  // Trigger — translucent fill, no `backdrop-filter` (substrate-blur recipe).
  background: var(--v2-glass-surface-2);
  border: 1px solid var(--v2-glass-stroke);
  border-radius: var(--v2-radius-md);
  outline: none;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: var(--v2-muted-foreground);
  }

  &:hover:not(:focus):not(:disabled) {
    border-color: var(--v2-glass-stroke-strong);
  }

  &:focus {
    border-color: var(--v2-primary);
    box-shadow: 0 0 0 3px oklch(0.62 0.21 295 / 0.25);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: var(--v2-muted);
  }
}
</style>
